
  <app-view *ngIf="item?.view" [items]="item.view?.data?.content" [info]="item?.view" ></app-view>

